module.exports = __webpack_public_path__ + "static/media/green.f0de95c9.png";